
interface FormRowProps {
    label: string;
    children: React.ReactNode;
    labelWidth?: string; 
}

export const FormRow: React.FC<FormRowProps> = ({
    label,
    children,
    labelWidth = "100px" 
}) => {
    return (
        <div className="row" >
            <label
                className="label"
                style={{ flex: `0 0 ${labelWidth}` }} 
            >
                {label}
            </label>
            <div >
                {children}
            </div>
        </div>
    );
};